<div #modal>
  <idp-loader
    *ngIf="loginHelperUtils.fromAdmin$ | async as loadSpinnerFromAdmin"
    [show]="loadSpinnerFromAdmin"
    [spinnerLabel]="'Loading...'"
    [customClass]="'fromAdmin'"
  ></idp-loader>
  <div
    *ngIf="!fromStandAlonePage"
    class="login-modal-backdrop"
    (click)="toggleModal()"
  ></div>
  <div
    [ngClass]="{
      advisorBanner: advisorBanner,
      removeScrollOnLoading: this.facade.loader$ | async,
      fromAdmin: loginHelperUtils.fromAdmin$ | async
    }"
    class="login-modal-container"
    [class.standalone]="fromStandAlonePage"
    [class.recognitionPage]="fromRecognitionPage"
    [class.centerPage]="centerPage"
    [class.infoIconClicked]="infoIconClicked"
    id="login-modal-wrapper"
    tabindex="0"
    #loginModal
  >
    <div class="login-modal-close-icon-box" *ngIf="!fromStandAlonePage">
      <span>&nbsp;</span>
      <button
        role="button"
        type="button"
        aria-label="Close"
        (click)="toggleModal()"
      ></button>
    </div>

    <div
      [ngClass]="{
        lastNameField: lastNameField,
        checkOutWarmState: checkOutWarmState
      }"
      class="login-loader"
    >
      <idp-loader
        *ngIf="this.facade.loader$ | async as loadSpinner"
        [show]="loadSpinner"
        [spinnerLabel]="'Loading...'"
      ></idp-loader>
    </div>
    <div [ngSwitch]="this.nextDisplayViewService.viewName$ | async">
      <ng-container *ngIf="this.facade.loginAuthScreenContent$ | async">
        <idp-login-authentication-screen
          *ngSwitchCase="viewName.LOGIN_CREDENTIALS_SCREEN"
          (formSubmitEvent)="onFormSubmit($event)"
          (focusInvalidField)="invalidField()"
          (inputChange)="inputChange()"
          (fieldFocusOut)="fieldFocusChange($event)"
          (footerLinkClick)="displayNextScreen($event)"
          (redirectTrackingClick)="
            trackAnalytics($event, viewName.LOGIN_CREDENTIALS_SCREEN)
          "
          (formAlertDisplay)="facade.formAlertDisplay()"
          (isLastNameEnabled)="isLastNameEnabled($event)"
          (logOut)="logOut.emit()"
          [content]="this.facade.loginAuthScreenContent$ | async"
          [toggleModalCallback]="toggleModal"
          [recognitionPage]="fromRecognitionPage"
          [ccrLoggedoutState]="(facade.fromCcrPage$ | async) ?? false"
          [checkOutWarmState]="checkOutWarmState"
        ></idp-login-authentication-screen>
      </ng-container>
      <ng-container *ngIf="this.forgotLoginFacade.forgotLoginContent$ | async">
        <idp-forgot-login
          *ngSwitchCase="viewName.FORGOT_LOGIN_SCREEN"
          (formSubmitEvent)="forgotLoginFormSubmit()"
          (focusInvalidField)="forgotLoginInvalidField()"
          (inputChange)="forgotLoginInputChange()"
          (fieldFocusOut)="forgotLoginFieldFocusOut($event)"
          [callBackFunction]="this.forgotLoginFacade.resetForm"
          [fromStandAlone]="fromStandAlonePage"
          [forgotLoginContent]="
            this.forgotLoginFacade.forgotLoginContent$ | async
          "
          (redirectTrackingClick)="
            trackAnalytics($event, viewName.FORGOT_LOGIN_SCREEN)
          "
          (closeOverlayMessage)="closeOverLayMessage()"
        ></idp-forgot-login>
      </ng-container>
      <ng-container
        *ngIf="checkEmailFacadeService.pageContent$ | async as content"
      >
        <idp-check-email
          *ngSwitchCase="viewName.CHECK_YOUR_EMAIL_SCREEN"
          (nextDisplayView)="checkEmailFacadeService.displayNextScreen($event)"
          [callBackFunction]="checkEmailFacadeService.resetEmailMessage"
          (closeOverlayMessage)="
            checkEmailFacadeService.showHideOverylayMessage($event)
          "
          (redirectTrackingClick)="
            trackAnalytics($event, viewName.CHECK_YOUR_EMAIL_SCREEN)
          "
          [pageData]="content"
        ></idp-check-email>
        <idp-check-email
          *ngSwitchCase="viewName.NEW_RESET_PASSWORD_CHECK_YOUR_EMAIL_SCREEN"
          (nextDisplayView)="checkEmailFacadeService.displayNextScreen($event)"
          [callBackFunction]="checkEmailFacadeService.resetEmailMessage"
          (closeOverlayMessage)="
            checkEmailFacadeService.showHideOverylayMessage($event)
          "
          (redirectTrackingClick)="
            trackAnalytics(
              $event,
              viewName.NEW_RESET_PASSWORD_CHECK_YOUR_EMAIL_SCREEN
            )
          "
          [pageData]="content"
        ></idp-check-email>
      </ng-container>
      <idp-unlock-your-account
        [pageData]="this.unlockAccountFacadeService.pageContent$ | async"
        (redirectTrackingClick)="
          trackAnalytics($event, viewName.UNLOCK_ACCOUNT_SCREEN)
        "
        (nextDisplayView)="displayNextScreen($event)"
        *ngSwitchCase="'unlockAccount'"
      ></idp-unlock-your-account>
      <ng-container
        *ngIf="
          resetPasswordFacade.resetPasswordContent$
            | async as resetPasswordFormContent
        "
      >
        <idp-reset-password
          *ngSwitchCase="viewName.RESET_PASSWORD_SCREEN"
          (formSubmitEvent)="onResetPasswordFormSubmit()"
          (focusInvalidField)="focusInvalidField()"
          (inputChange)="resetPasswordFormInputChange($event)"
          (fieldFocusOut)="resetPasswordFormFieldFocusChange($event)"
          [content]="resetPasswordFormContent"
          (closeOverlayMessage)="
            resetPasswordFacade.showHideOverylayMessage($event)
          "
          (redirectTrackingClick)="
            trackAnalytics($event, viewName.RESET_PASSWORD_SCREEN)
          "
          (nextDisplayView)="displayNextScreen($event)"
        ></idp-reset-password>
      </ng-container>
      <ng-container
        *ngIf="
          recoveryOptionsFacade.recoveryOptionsContent$
            | async as recoveryOptionsContent
        "
      >
        <idp-recovery-options
          *ngSwitchCase="viewName.CHOOSE_RECOVERY_OPTIONS_SCREEN"
          [content]="recoveryOptionsContent"
          (formSubmitEvent)="onRecoveryOptionsFormSubmit()"
          (closeOverlayMessage)="
            recoveryOptionsFacade.showHideOverlayMessage($event)
          "
        ></idp-recovery-options>
      </ng-container>

      <ng-container
        *ngIf="
          recoverSQAFacadeService.pageContent$ | async as recoveryOptionsContent
        "
      >
        <idp-recover-by-security-questions
          *ngSwitchCase="viewName.SECURITY_QUESTION_ANSWER_SCREEN"
          (focusInvalidField)="recoverbySQAFormInvalidField()"
          (inputChange)="sqaInputChange()"
          (fieldFocusOut)="sqaFieldFocusChange($event)"
          (formSubmitEvent)="onSecurityFormSubmit($event)"
          [content]="recoveryOptionsContent"
          (closeOverlayMessage)="recoverSQACloseOverlayMessage()"
          (redirectTrackingClick)="
            trackAnalytics($event, viewName.SECURITY_QUESTION_ANSWER_SCREEN)
          "
        ></idp-recover-by-security-questions>
      </ng-container>

      <idp-login-help-screen
        *ngSwitchCase="viewName.LOGIN_HELP_SCREEN"
        [pageData]="this.loginHelpScreenFacadeService.pageContent$ | async"
        (nextDisplayView)="displayNextScreen($event)"
        (redirectTrackingClick)="
          trackAnalytics($event, viewName.LOGIN_HELP_SCREEN)
        "
      ></idp-login-help-screen>
      <ng-container
        *ngIf="
          createPasswordFacade.resetPasswordContent$ | async as formContent
        "
      >
        <idp-reset-password
          *ngSwitchCase="viewName.CREATE_PASSWORD_SCREEN"
          (formSubmitEvent)="
            createPasswordFacade.onResetPasswordFormSubmit(true)
          "
          (focusInvalidField)="focusInvalidField()"
          (inputChange)="
            createPasswordFacade.resetPasswordFormValueChange($event)
          "
          (fieldFocusOut)="
            createPasswordFacade.resetPasswordFormFocusChange($event)
          "
          [content]="formContent"
          (closeOverlayMessage)="
            createPasswordFacade.showHideOverylayMessage($event)
          "
        ></idp-reset-password>
      </ng-container>
      <ng-container
        *ngIf="createMyPasswordFacade.pageContent$ | async as pageContent"
      >
        <idp-create-my-password
          *ngSwitchCase="viewName.SET_PASSWORD_SCREEN"
          (formSubmitEvent)="createMyPasswordFacade.onFormSubmit($event)"
          (focusInvalidField)="createMyPasswordFocusInvalidField()"
          (inputChange)="createMyPasswordFacade.onFormValueChange()"
          (fieldFocusOut)="createMyPasswordFacade.onFormFocusChange($event)"
          [content]="pageContent"
          [callBackFunction]="createMyPasswordFacade.resetForm"
          (closeOverlayMessage)="
            createMyPasswordFacade.showHideOverylayMessage($event)
          "
          (updatePasswordHint)="
            createMyPasswordFacade.updatePasswordHintStatus($event)
          "
          (togglePassword)="createMyPasswordFacade.togglePassword()"
        ></idp-create-my-password>
      </ng-container>
      <idp-recover-your-account
        *ngSwitchCase="viewName.RECOVER_ACCOUNT_SCREEN"
        [pageData]="this.recoverYourAccountService.pageContent$ | async"
        [emailExpired]="
          (this.recoverYourAccountService.emailExpired$ | async) || false
        "
        (nextDisplayView)="facade.formAlertDisplay(); displayNextScreen($event)"
      ></idp-recover-your-account>
      <ng-container
        *ngIf="
          addEmailAddressFacadeService.addEmailAddressContent$
            | async as pageContent
        "
      >
        <idp-add-email-address
          *ngSwitchCase="viewName.ADD_EMAIL_ADDRESS_SCREEN"
          [content]="pageContent"
          (formSubmitEvent)="addEmailAddressFacadeService.onFormSubmit()"
          (focusInvalidField)="focusInvalidField()"
          (inputChange)="
            addEmailAddressFacadeService.addEmailAddressFormValueChange()
          "
          (fieldFocusOut)="
            addEmailAddressFacadeService.addEmailAddressFormFocusChange($event)
          "
          (resetForm)="addEmailAddressFacadeService.resetForm()"
          (closeOverlayMessage)="
            addEmailAddressFacadeService.showHideOverylayMessage($event)
          "
        ></idp-add-email-address>
      </ng-container>
      <ng-container
        *ngIf="this.addSqaFacade.addSqaContent$ | async as addSqaFormContent"
      >
        <idp-add-sqa
          *ngSwitchCase="viewName.ADD_SECURITY_QUESTION_ANS_SCREEN"
          [content]="addSqaFormContent"
          (fieldFocusOut)="addSqaFacade.addSqaFormFocusChange($event)"
          (focusInvalidField)="focusInvalidField()"
          (formSubmitEvent)="addSqaFacade.onAddSqaFormSubmit()"
          (closeOverlayMessage)="addSqaFacade.displayOverylayMessage($event)"
          (inputChange)="addSqaFacade.formValueChange()"
          (resetForm)="addSqaFacade.resetForm()"
        ></idp-add-sqa>
      </ng-container>
      <ng-container
        *ngIf="
          this.addAddressFacade.addAddressContent$
            | async as addAddressFormContent
        "
      >
        <idp-add-address
          *ngSwitchCase="viewName.ADD_ADDRESS_SCREEN"
          [content]="addAddressFormContent"
          (countryChange)="addAddressFacade.getAddressDetails($event)"
          (fieldFocusOut)="addAddressFacade.addAddressFormFocusChange($event)"
          (focusInvalidField)="focusInvalidField()"
          (formSubmitEvent)="addAddressFacade.onFormSubmit()"
          (inputChange)="addAddressFacade.formValueChange()"
          (resetForm)="addAddressFacade.resetForm()"
          (closeOverlayMessage)="
            addAddressFacade.showHideOverlayMessage($event)
          "
        ></idp-add-address>
      </ng-container>
    </div>
  </div>
</div>

<form
  class="hiddenForm"
  #loginStandaloneRedirectForm
  id="loginStandaloneRedirectForm"
  method="POST"
  [action]="bauRefreshURL"
>
  <div *ngFor="let key of queryParamKeys">
    <input
      *ngIf="paramsToIgnore.indexOf(key) === -1"
      type="hidden"
      [name]="key"
      [value]="queryParams[key]"
    />
  </div>
  <button type="submit"></button>
</form>
